var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.93933 6.88893L7.88933 11.8389L6.47533 13.2529L0.111328 6.88893L6.47533 0.524929L7.88933 1.93893L2.93933 6.88893Z","fill":"#727281"}));
}

Arrow.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
